import journeysQueries from "../gql/queries";
import { fetchFromGraphql } from "entities/helpers/gqlCall";

export const getTaskCount = async (
  selectedDate, // required
  taskOwnerUserId, // required
  taskStatuses, // required
  journeyTaskIds = null,
  taskActionTypes
) => {
  const query = journeysQueries.fetchTaskCount;

  const params = {
    journeyTaskIds,
    selectedDate,
    taskOwnerUserId,
    taskStatuses,
    taskActionTypes,
  };

  const { taskCount } = await fetchFromGraphql(query, params, "taskCount");

  Object.keys(taskCount).forEach(function (key) {
    if (taskCount[key] === null) {
      taskCount[key] = 0;
    }
  });

  return taskCount;
};
